import {useGlobalStore} from "@/store/useGlobalStore";
import payloadBuilder from "@/utilities/payload-builder";

export default function transactionRequests() {
    const globalStore = useGlobalStore()
    async function getGLAccounts() {
        let data = []
        const responseList = await payloadBuilder('coa', 'all').execute();
        if(responseList){
            let data = responseList.data.data
            data = data.filter(datum => datum.node !== 0)
            data = data.map(datum => {
                const isDisabled = datum.status === 0
                return {
                    ...datum,
                    disabled: isDisabled
                }
            })
            globalStore.glAccounts = data
        }
        return data
    }

    async function getSLAccounts() {
        let data = []
        const responseList = await payloadBuilder('entities', 'list')
                .addPayload('conditions', {params: {type: 'payor_list'}}).execute();
        if(responseList){
            let data = responseList.data.data
            data = data.map(datum => {
                const isDisabled = datum.status === 0
                return {
                    ...datum,
                    disabled: isDisabled
                }
            })
            globalStore.slAccounts = data
        }
        return data
    }

    async function getBranches() {
        let data = []
        const conditions = { type: 'branches' }
        const responseList = await payloadBuilder('setup', 'list').addPayload('conditions', {
            params: conditions
        }).execute();
        if(responseList){
            let data = responseList.data.data
            data = data.map(datum => {
                const isDisabled = datum.status === 0
                return {
                    ...datum,
                    disabled: isDisabled
                }
            })
            globalStore.branches = data
        }
        return data
    }

    async function getItemCategories() {
        let data = []
        const conditions = { type: 'item_category' }
        const responseList = await payloadBuilder('setup', 'list').addPayload('conditions', {
            params: conditions
        }).execute();
        if(responseList){
            let data = responseList.data.data
            data = data.map(datum => {
                const isDisabled = datum.status === 0
                return {
                    ...datum,
                    disabled: isDisabled
                }
            })
            globalStore.categories = data
        }
        return data
    }

    async function getSystemConfiguration() {
        try {
            const SYSTEM = process.env.VUE_APP_SYSTEM
            const responseList = await payloadBuilder('sysconfig', 'get', 'guest').addPayload('conditions', {
                system: SYSTEM ?? 'system_code'
            }).execute();
            if(responseList){
                let data = responseList.data.data

                localStorage.setItem('sys_config', JSON.stringify(data))
                globalStore.sys_configs = data

                let icon = document.getElementById('sys_icon')
                if(icon) icon.setAttribute('href', data?.['SYS_LOGO'] ?? process.env.VUE_APP_SYSTEM_LOGO)

                document.querySelector('#sys_title').textContent = (data?.['SYS_BRAND'] + ' ' + data?.['SYS_TYPE'])
                    ?? (process.env.VUE_APP_SYSTEM_BRAND + ' ' + process.env.VUE_APP_SYSTEM_NAME)
                return data
            }
        } catch (error) {
            return []
        }
    }

    async function listReport(request = 'report', type = 'list', conditions) {
        try {
            // conditions/combinations for report filter:
            // filter type     |  value key   |     key data type
            // ------------------------------------------------------------
            // range           |    range     |      array [date, date]
            // month           |    month     |      object { month, year }
            // as_of           |     to       |      date

            const responseList = await payloadBuilder(request, type).addPayload('conditions', {
                params: conditions
            }).execute();
            if(responseList){
                let data = responseList.data.data ?? []
                if(responseList.data.statusCode) {
                    return {
                        'is_error': true,
                        'error_message': responseList.data.error ?? '',
                        'data': responseList.data
                    }
                }

                return {
                    'is_error': false,
                    'error_message': responseList.data.error ?? '',
                    'data': data
                }
            }
        } catch (ex) {
            return {'is_error': true, error_message: ex}
        }
    }

    const downloadDocument = async (conditions) => {
        let response = await payloadBuilder("report", "print")
            .addPayload('conditions', { params: conditions }).execute()
        if(response){
            if(response.data.statusCode) {
                return {
                    'is_error': true,
                    'error_message': response.data.error ?? '',
                    'data': response.data
                }
            }

            await createDownloadable(response.data.data.file, "Account Transactions.xlsx")
            return {
                is_error: false,
                'error_message': response.data.error ?? '',
                'data': response.data
            }
        }
    }
    async function createDownloadable(data, file_name, media_type = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,') {
        return new Promise((resolve, reject) => {
            let mediaType = media_type;
            const link = document.createElement('a');
            link.href = mediaType + data;
            link.setAttribute('download', file_name);
            link.style.display = 'none';

            document.body.appendChild(link);
            link.click();

            link.onload = () => {
                window.URL.revokeObjectURL(fileURL);
                link.remove();
                resolve();
            };

            link.onerror = (err) => {
                window.URL.revokeObjectURL(fileURL);
                link.remove();
                reject(err);
            };
        });
    }

    return {
        getGLAccounts,
        getSLAccounts,
        getBranches,
        getItemCategories,
        listReport,
        downloadDocument,
        getSystemConfiguration
    }
}